<template>

  <div>
    <div v-if="srcList.length>0">
      <div v-for="(item,index) in srcList" v-show="!(item[0]=='id'||item[0]=='orderId'||item[0]=='merNo'||item[1]==''||item[1]==null)" :key="index" style="display:inline-block;width:120px;height:150px;vertical-align:top;">
        <div v-if="!(item[0]=='id'||item[0]=='orderId'||item[0]=='merNo'||item[1]==''||item[1]==null)">
          <el-image style="width: 100px; height: 100px;margin-right:20px;" :src="item[1]" :preview-src-list="srcList1" />
          <div v-for="(i,index) in uploadArr" v-show="i.fileType == item[0]" :key="index" style="display:inline;margin-top:20px;">{{ i.title }}</div>
        </div>
      </div>
    </div>
    <div v-else><span>暂时没有图片...</span></div>
  </div>
  
</template>
<script>
export default {
  props: {
    'srcList': Array,
    'srcList1': Array,
    'uploadArr': Array
  }
}
</script>
